import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import WhyImperfectionSection from "./components/WhyImperfectionSection";
import ResearchSection from "./components/ResearchSection";
import FromFlawSection from "./components/FromFlawSection";
import WhyBagCharmsSection from "./components/WhyBagCharmsSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#F5F3EF]" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <WhyImperfectionSection />
        <ResearchSection />
        <FromFlawSection />
        <WhyBagCharmsSection />
      </main>
      <Footer />
    </div>
  );
}
